//
// PortableCollator.js
// commons
//
// Generated by Robots v0.
// Copyright (c) SAS Institute Inc. All rights reserved.
//
// DO NOT EDIT THIS FILE. IT IS GENERATED BY ROBOTS.
//
// Disable camelcase rule for generated code.
/* eslint-disable camelcase */
import { createModule } from "../../moduleBuilder";
import ClosetObject from "../../ClosetObject";
import "../../lib";

var PortableCollator = createModule("commons::PortableCollator", [], ClosetObject, [
    ,
    ,
    ,
    ,
    {
        getSortedIndices: [[3],[7]],
        compare: [2,7,7],
        setStrength: [0,4],
        compareAndYieldIntegerResult: [4,7,7],
        getSortTypeName: [7],
    },
    ,
    ,
]);
export default PortableCollator;
